import { createSlice } from "@reduxjs/toolkit";

const internalCandidateStaticValueSlice = createSlice({
  name: "internalCandidateStaticValue",
  initialState: {
    data: null,
    educationData: null,
    peviousExperienceData: null,
    officialReferenceData: null,
    status: "idle",
    error: null,
  },
  reducers: {
    addPersonalDetailsValue: (state, action) => {
      state.data = action.payload;
    },
    addEducationSkillValue: (state, action) => {
      state.educationData = action.payload;
    },
    addPreviousExperienceValue: (state, action) => {
      state.peviousExperienceData = action.payload;
    },
    addOfficialReferenceValue: (state, action) => {
      state.officialReferenceData = action.payload;
    },
    removePersonalDetailsValue: (state, action) => {
      state.data = null;
    },
    removeEducationSkillValue: (state, action) => {
      state.educationData = null;
    },
    removePreviousExperienceValue: (state, action) => {
      state.peviousExperienceData = null;
    },
    removeOfficialReferenceValue: (state, action) => {
      state.officialReferenceData = null;
    },
  },
});

export const {
  addPersonalDetailsValue,
  removePersonalDetailsValue,
  removeEducationSkillValue,
  addEducationSkillValue,
  addPreviousExperienceValue,
  removePreviousExperienceValue,
  addOfficialReferenceValue,
  removeOfficialReferenceValue,
} = internalCandidateStaticValueSlice.actions;

export default internalCandidateStaticValueSlice.reducer;
